import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Link from 'next/link';
import { Mail, MapPin, Phone } from 'lucide-react';

const footerLinks = {
  Music: [
    { label: 'Singles', href: '/music' },
    { label: 'Albums', href: '/music' },
    { label: 'EPs', href: '/music' },
    { label: 'Collaborations', href: '/music' },
  ],
  Artist: [
    { label: 'About', href: '/about' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'Videos', href: '/videos' },
    { label: 'News', href: '/news' },
  ],
  Events: [
    { label: 'Upcoming Shows', href: '/events' },
    { label: 'Tour Dates', href: '/events' },
    { label: 'Past Events', href: '/events' },
    { label: 'Book Artist', href: '/booking' },
  ],
  Connect: [
    { label: 'Newsletter', href: '/#news' },
    { label: 'Contact', href: '/booking' },
  ],
};

export default function PublicFooter() {
  return (
    <footer className="bg-card border-t border-border pt-16 pb-8">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <AppLogo size={40} />
              <span className="font-sans text-xl font-800 tracking-tight text-gradient-gold">HADATHA</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Ester Edson — The White Lioness. Tanzanian Afro &amp; Contemporary African music artist from the Southern Highlands of Tanzania.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <MapPin size={12} className="text-primary" />
                Dar es Salaam, Tanzania 🇹🇿
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Mail size={12} className="text-primary" />
                <a href="mailto:info@hadathatz.com" className="hover:text-primary transition-colors">info@hadathatz.com</a>
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Phone size={12} className="text-primary" />
                <a href="tel:+255718863913" className="hover:text-primary transition-colors">+255 718 863 913</a>
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks)?.map(([section, links]) => (
            <div key={`footer-section-${section}`}>
              <p className="text-xs font-700 tracking-widest uppercase text-foreground mb-4">{section}</p>
              <ul className="space-y-2">
                {links?.map((link) => (
                  <li key={`footer-link-${section}-${link?.label}`}>
                    <Link href={link?.href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-border pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} Hadatha (Ester Edson). All rights reserved.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a href="https://music.apple.com/us/artist/hadatha/1611554470" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-primary transition-colors">Apple Music</a>
            <a href="https://soundcloud.com/johnbruddatz" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-primary transition-colors">SoundCloud</a>
            <a href="https://www.youtube.com/watch?v=JsSVXOFFypU" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-primary transition-colors">YouTube</a>
          </div>
        </div>

        {/* Powered by credit */}
        <div className="border-t border-border mt-6 pt-4 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} Powered by{' '}
            <a
              href="https://wa.link/p98sxg"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline transition-colors"
            >
              Master Kolimba
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}